module.exports = "<router-outlet></router-outlet>"


//////////////////
// WEBPACK FOOTER
// /app/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main